/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseSupplier
 */
export interface GetPaymentRequestDetail200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'accountType': GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'companyName': string;
}

export const GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum = typeof GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum[keyof typeof GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum];


